
import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import BodyRegister1 from "@/components/register/BodyRegister1.vue";
import BodyRegister2 from "@/components/register/BodyRegister2.vue";
import BodyRegister3 from "@/components/register/BodyRegister3.vue";
@Component({
  components: {
    BodyRegister3,
    BodyRegister2,
    BodyRegister1,
  },
})
export default class BodyRegister extends Vue {
  @Prop({ default: [] })
  private items!: Array<any>;
  @Prop({ default: 1 })
  private templateNumber!: number;
}
